<template>
    <div style="height: 100%; background-color: #FFFFFF; padding: 1rem; padding-top: 2rem;">
        <div class="image-container" v-if="this.semDados === false">
          <img class="image-box" src="@/assets/ilustracao_erro.svg" alt="">
          <div class="title-image">Nenhum gráfico encontrado</div>
          <div class="text-image">Verifique os parâmetros ao lado e click em buscar para exibir os resultados</div>
        </div>
        <div v-else>
          <div class="header-custo">
            <div class="title-Chart">
               <div class="title-Chart">Gráfico Custo x Empreendimentos</div>
            </div>
            <div class="buton_download">
              <button class="buttonDow" @click="openpopPdf()"><i class="fas fa-download" style="color: #ffffff;"></i></button>
            </div>
          </div>
          <div class="chart-container">
              <canvas id="myChart"></canvas>
              <div id="legends"></div>
            </div>
        </div>
        <!-- <div class="info-value">
          <div style='display: flex; gap: 0.5rem; flex-direction: column; align-items: flex-end;'>
            <div style='color:#008148;'><strong>{{ somaTotal }}</strong></div>
            <div >N° Chamados</div>
          </div>
          <div style='display: flex; flex-direction: column; align-items: flex-end;'>
            <div style='color:#008148'><strong>{{ formatMoney(somaValor) }}</strong></div>
            <div>Valor Total</div>
          </div>
        </div> -->

        <b-modal
            hide-footer
            centered
            size="xl"
            ref="popup-pdf-modal"
            id="history-lote">
            <template #modal-header>
                <div class="d-flex justify-content-between align-items-center align-content-center w-100" style="color:#fff">
                    <p id="title-modal">RELATÓRIO DE CUSTOS</p>
                    <div class="d-flex">
                        <i class="fa fa-download d-flex mr-4 justify-content-between align-items-center align-content-center"
                            style="color: #fff; cursor: pointer;"
                            @click="generatePDF"
                            v-b-tooltip.hover.bottom title="Download"></i>
                        <div @click="closeModal" class="w-100" id="closed-modal"><i class="fa fa-times" style="cursor: pointer;" v-b-tooltip.hover.bottom title="Fechar"></i></div>
                    </div>
                </div>
            </template>
            <div class="container_pdf">
              <section slot="pdf-content">
                      <img class="cabecalho" src="../../../../../../../static/img/realestate/relatorio/Header_vertical.png"/>
                      <!-- <img src="/static/img/logotipo/menu/Z-INCORPORAÇÕES7.png" class="size-logo-inco-pdf"/> -->
                </section>
                <div class="title-reports">
                  Relatório de Custos  {{ dataRelatorio }}
                </div>
                <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="filter-text">
                      <div class="border-filter">
                        <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                      </div>
                      <div class="header_filtro">Filtros Utilizados</div>
                    </div>
                    <div class="container_header_filtro">
                      <div class="status_filtro">
                        Status do Chamado:  <strong class="filtrostatus">{{this.StatusFiltro == 'N/D' ? 'TODOS' : this.StatusFiltro}}</strong>
                      </div>
                      <div class="periodo_filtro">
                        Período:  <strong  class="filtrostatus">{{this.periodoFiltro}}  ({{ this.dataInicio }} - {{ this.dataFim}})</strong>
                      </div>
                    </div>

                    <!-- <div class="container-filtro-pato-empre">
                      <div class="empreendimento" >
                        <div><strong>Empreendimentos:</strong></div>
                        <div v-for="(data, index) in empreedimentoArray" v-bind:key="index">{{TotalEmpreendimento === 1 ? data.nomeEmpreendimento : (data.nomeEmpreendimento + (index === empreedimentoArray.length - 1 ? '.' : ', '))}}</div>
                      </div>
                      <div class="patologia">
                        <div><strong>Patologias:</strong></div>
                        <div  v-for="(data, index) in patologiaPdfArray" v-bind:key="index">{{Totalocorrencias === 1 ? data.patologia + ':' + ' Total ' +  data.quantidadeOcorrencia : (data.patologia + ':' + ' Total ' +  data.quantidadeOcorrencia + (index === patologiaPdfArray.length - 1 ? '.' : ', '))}}</div>
                      </div>
                    </div> -->
                </div>
                <div class="report-qta">
                  <div class="numerochamados">
                    <div class="qtachamado">
                      {{total}}
                    </div>
                    <div class="text-filter">
                      N° Chamados
                    </div>
                  </div>
                  <div class="numerochamados">
                    <div class="qtachamado">
                      {{formatMoney(TotalInsumos)}}
                    </div>
                    <div class="text-filter">
                      Valor Total
                    </div>
                  </div>
                </div>
              </div>
                <div class="container_pdffiltro" v-for="(data, index) in ocorrencias" v-bind:key="index">
                  <div class="enterprise-report">
                    <div class="enterprise-report-name">{{ data.empreendimento }}</div>
                    <div class="enterprise-report-statistic">
                      <div class="enterprise-report-total">N° Chamados<strong class="ml-2 enterprise-report-totalnumber"> {{ formatLength(data.custoTotalByEmpreendimento.length) }}</strong></div>
                      <div class="enterprise-report-total">Valor Total<strong class="ml-2 enterprise-report-totalnumber"> {{ formatMoney(data.insumoEMpreendimento) }}</strong></div>
                    </div>
                  </div>
                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Código</div>
                    <div class="tecnico_oce font">Técnico</div>
                    <div class="engenheiro_oce font">Engenheiro</div>
                    <div class="causa_raiza font">Causa Raiz</div>
                    <div class="valor_oce font">Custo</div>
                  </div>
                  <div class="container_ocorrencias" v-for=" obj in data.custoTotalByEmpreendimento" :key="obj.id">
                    <div class="numero_oce_result font_result">{{obj.testeCodigo}}</div>
                    <div class="tecnico_oce_result font_result">{{obj.nomeTecnico !== null ? obj.nomeTecnico : '-'}}</div>
                    <div class="engenheiro_oce_result font_result">{{obj.nomeEngenheiro !== null ? obj.nomeEngenheiro : '-'}}</div>
                    <div class="engenheiro_oce_result font_result">{{obj.problemaRaizText }}</div>
                    <div class="valor_oce_result font_result">{{obj.valorInsumo !== null ? formatMoney(obj.valorInsumo) : '-' }}</div>
                  </div>
                </div>
                <div class = " html2pdf__page-break "></div>
                <div v-if="this.imagem != null" class="img_grafico">
                  <div class="title-Chart_modal">
                   Gráfico Custo x Empreendimento
                  </div>
                  <img class="img-modal-details" :src="this.imagem.src">
                </div>
            </div>
        </b-modal>

      <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      filename= "Relatorio Custos"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
                <div class="conteiner_pdf_grafico">
                  <div class="pdf-header">
                    <div class="nome_relatorio-pdf">
                      RELATÓRIO DE CUSTOS {{ ' ' + dataFormatada}}
                    </div>
                  </div>
                  <div class="report-filter">
                    <div class="filtro_parametros-pdf">
                      <div class="filter-text">
                        <div class="border-filter">
                          <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                        </div>
                        <div class="header_filtro">Filtros Utilizados</div>
                      </div>
                      <div class="container_header_filtro">
                        <div class="status_filtro">
                          Status do Chamado: <strong class="filtrostatus">{{this.StatusFiltro == 'N/D' ? 'TODOS' : this.StatusFiltro}}</strong>
                        </div>
                        <div class="periodo_filtro">
                          Período:  <strong  class="filtrostatus">{{this.periodoFiltro}}  ({{ this.dataInicio }} - {{ this.dataFim }})</strong>
                        </div>
                      </div>
                    </div>
                    <div class="report-qta-pdf">
                      <div class="numerochamados-pdf">
                        <div class="qtachamado">
                          {{total}}
                        </div>
                        <div class="text-filter">
                          N° Chamados
                        </div>
                      </div>
                      <div class="numerochamados-pdf">
                        <div class="qtachamado">
                          {{formatMoney(TotalInsumos)}}
                        </div>
                        <div class="text-filter">
                          Valor Total
                        </div>
                      </div>
                    </div>
                  </div>

                <div class="container_pdffiltro" v-for="(data, index) in ocorrencias" v-bind:key="index">
                  <div class="enterprise-report">
                    <div class="enterprise-report-name">{{ data.empreendimento }}</div>
                    <div class="enterprise-report-statistic">
                      <div class="enterprise-report-total">N° Chamados<strong class="ml-2 enterprise-report-totalnumber"> {{ formatLength(data.custoTotalByEmpreendimento.length) }}</strong></div>
                      <div class="enterprise-report-total">Valor Total<strong class="ml-2 enterprise-report-totalnumber"> {{ formatMoney(data.insumoEMpreendimento) }}</strong></div>
                    </div>
                  </div>
                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Código</div>
                    <div class="tecnico_oce font">Técnico</div>
                    <div class="engenheiro_oce font">Engenheiro</div>
                    <div class="causa_raiza font">Causa Raiz</div>
                    <div class="valor_oce font">Custo</div>
                  </div>
                  <div class="container_ocorrencias" v-for=" obj in data.custoTotalByEmpreendimento" :key="obj.id">
                    <div class="numero_oce_result font_result">{{obj.testeCodigo}}</div>
                    <div class="tecnico_oce_result font_result">{{obj.nomeTecnico !== null ? obj.nomeTecnico : '-'}}</div>
                    <div class="engenheiro_oce_result font_result">{{obj.nomeEngenheiro !== null ? obj.nomeEngenheiro : '-'}}</div>
                    <div class="engenheiro_oce_result font_result">{{obj.problemaRaizText }}</div>
                    <div class="valor_oce_result font_result">{{obj.valorInsumo !== null ? formatMoney(obj.valorInsumo) : '-' }}</div>
                  </div>
                </div>
                 <div class = " html2pdf__page-break "></div>
                  <div v-if="this.imagem != null" class="img_grafico">
                    <div class="title-Chart_modal">
                      Gráfico Custo x Empreendimento
                    </div>
                    <img class="img-modal-details" :src="this.imagem.src">
                  </div>
              </div>
          </section>
    </vue-html2pdf>
    </div>
</template>

<script>
import ChartTotalCost from './chartTotalCost.js'
export default ChartTotalCost
</script>

<style scoped>
    .info-value{
      position: absolute;
      display:flex;
      font-size: 22px;
      gap: 2vw;
      flex-direction: column;
      font-family: 'Poppins';
      top: 35rem;
      right: 4rem;
    }
    #legends {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    div #legenda-grafico{
      display: flex;
      flex-wrap: wrap;
      /* width: 25%; */
    }
    .enterprise-report-statistic{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .enterprise-report,
    .container_ocorrencias_filtradas,
    .container_ocorrencias,
    .numero_oce_result,
    .empreendimento_oce_resul,
    .causa_raiza_result,
    .responsavel_oce-result{
      break-inside: avoid
    }
    .container-filtro{
      break-inside: avoid;
    }
    .enterprise-report{
      padding: 0.5rem 1rem 0.5rem 0.5rem;
      border-radius: 10px 10px 0px 0px;
      background: #F4F4F4;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .enterprise-report-name{
      color: #1A1818;
      font-family: 'Poppins';
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px;
    }
    .enterprise-report-total{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
    }
    .enterprise-report-totalnumber{
      color: #008148;
      text-align: center;
      font-family: 'Poppins';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px;
    }
    .cabecalho{
      width: 100%;
      margin-bottom: 2rem;
    }
    .title-reports{
      color: #1A1818;
      font-family: 'Poppins';
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 150% */
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
    }
    .report-filter{
      display: flex;
      gap: 1rem;
    }
    .filtro_parametros-peq{
      width: 100%;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.5rem
    }
    .filter-text{
      display:flex;
      align-items: center;
      padding: 1rem 0 0 1rem;
    }
    .border-filter{
      border-radius: 5px;
      background: #E8E8E8;
      width: 23px;
      height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right:1rem;
    }
    .icon-filter{
      color:#2E973D;
    }
    .filtrostatus{
      color: #1A1818;
      font-size: 16px;
      font-style: normal;
      font-weight: 800;
      line-height: 27px; /* 225% */
    }
    .numerochamados{
      width: 215px;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .numerochamados-pdf{
      width: 215px;
      border-radius: 10px;
      background: #F4F4F4;
      padding: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .qtachamado{
      color: #008148;
      text-align: center;
      font-family: 'Poppins';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 27px; /* 103.846% */
    }
    .text-filter{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
    }
    .text-filter-small{
      color: #1A1818;
      text-align: center;
      font-family: 'Poppins';
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 337.5% */
    }
    .report-qta{
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .report-qta-pdf{
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      height: 100%
    }
    .nome_relatorio {
      display: flex;
      width: 100%;
      justify-content: end;
      font-size: 16px;
      font-weight: bold;
      color: rgb(54, 54, 54);
      font-family:'Segoe UI';
    }
    .nome_relatorio-pdf {
      display: flex;
        width: 100%;
        font-size: 22px;
        font-weight: bold;
        color: rgb(54, 54, 54);
        font-family:'Poppins';
        margin: 0.25rem 0 1rem 0;
        background: transparent;
        justify-content: center;
    }
    .container_pdffiltro-pdf{
      margin-top: 2rem;
      width: 100%;
      border-radius: 10px;
      border: 1px solid #F4F4F4;
      break-after: avoid;
    }
    .filtro_parametros-pdf{
      width: 100%;
      padding: 0.5rem;
      background: #F4F4F4;
      border-radius: 5px;
    }
    .container-filtro-pato-empre-pdf {
        padding: 1rem;
        display: grid;
        border: solid 1px;
        grid-auto-columns: 1fr;
        grid-auto-rows: 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 0px 0px;
    }
    .img-modal-details {
      margin-top: 0.5rem;
      width: 100%;
    }
    .title-Chart_modal{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 100%;
      justify-content: center;
      margin-bottom: 0rem;
    }
    .img_grafico{
      margin-top: 3rem;
    }
    .font_result_total{
        padding-right: 1rem;
        font-size:  15px;
        font-weight: bold;
        color: rgb(114, 114, 114);
        font-family:'Poppins';
        margin: 0;
    }
    .totalizados_result {
      display: flex;
      justify-content: end;
      align-items: center;
      grid-area: 1 / 1 / 2 / 2;
    }
    .container_ocorrencias_folder {
      width: 100%;
      height: 2rem;
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-template-columns: 1fr;
      gap: 0px 0px;
    }
    .concluido{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #008148;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }

  .cancelado{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #960505;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }
    .vistoria{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: #565656;
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 9px;
    }
    .andamento{
      width: 5rem;
      border-radius: 10px;
      height: 5px;
      background: rgb(13, 39, 184);
      color: #F4F4F4;
      display: flex;
      font: normal normal 600 7px/20px Segoe UI;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }
    .container_ocorrencias {
      width: 100%;
      display: flex;
      justify-content: space-around;
      border: #f4f4f4 1px solid
    }
    .container_ocorrencias > div {
      width: calc(33.33% - 10px);
      margin: 5px;
    }
    .container_ocorrencias_filtradas {
      width: 100%;
      height: 2rem;
      border-radius: 5px 5px 0 0;
      background: #2E973D;
      display: flex;
      justify-content: space-around;
    }
    .container_ocorrencias_filtradas > div {
      width: calc(33.33% - 10px); /* Adjust the width according to your preference */
      margin: 5px; /* Add margin between the div elements */
    }

    .numero_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .empreendimento_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tecnico_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .engenheiro_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .valor_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .causa_raiza_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .situacao_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .situacao {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .font_result{
        color: #1A1818;
        font-family:'Poppins';
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .font{
        color: #FFF;
        font-family: 'Poppins';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .numero_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .empreendimento_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tecnico_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .engenheiro_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .causa_raiza {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .valor_oce {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .situacao {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .container_pdffiltro{
      margin-top: 2rem;
      width: 100%;
      border-radius: 10px;
      border: 1px solid #F4F4F4;
      break-inside: avoid;
    }
    .empreendimento {
      width: 100%;
      text-align: center;
      height: fit-content;
    }
    .patologia { text-align: center;}
    .container-filtro-pato-empre {
        padding: 10px;
        display: grid;
        border: solid 1px;
        grid-auto-columns: 1fr;
        grid-auto-rows: 1fr;
        grid-template-columns: 1fr 1fr;
        gap: 0px 0px;
    }
    .status_filtro {
      color: #1A1818;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
      font-family: 'Poppins';
    }
    .periodo_filtro {
      color: #1A1818;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px; /* 225% */
      font-family: 'Poppins';
    }
    .container_header_filtro{
      display: flex;
      padding: 1rem;
      flex-direction: column;
      gap: 1rem;
    }
    .header_filtro{
      color: #1A1818;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 27px; /* 192.857% */
      font-family: 'Poppins';
    }
    .filtro_parametros{
      margin-top: 2rem;
      width: 100%;
      height: fit-content;
      background: rgb(236, 236, 236);
      border-radius: 5px;
      padding: 0.5rem
    }
    .size-logo-inco-pdf{
        height: 50px;
        width: 250px;
    }
    .pdf-header{
      margin-bottom: 0.5rem;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .conteiner_pdf_grafico{
      padding: 1rem;
    }
    .container_pdf {
      height: 60vh;
      overflow: auto;
      width: 100%;
      border-radius: 5px;
      border-bottom: 1px solid #D4D4D4;
    }
    .container_pdf::-webkit-scrollbar-track {
      background-color: #F4F4F4;
      border-radius: 5px;
    }
    .container_pdf::-webkit-scrollbar {
        width: 6px;
        border-radius: 5px;
        background: #F4F4F4;
    }
    .container_pdf::-webkit-scrollbar-thumb {
        background: #dad7d7;
        border-radius: 5px;
    }
    #title-modal{
        font-size: 18px;
        font-weight: bold;
        color: white;
        font-family:'Segoe UI';
        margin: 0;
    }
    .buttonDow{
      height: 30px;
      width: 2.5rem;
      border-radius: 5px;
      border: transparent;
      background: #008148;
    }
    .buton_download{
      margin-top: 0.3rem;
      display: flex;
      justify-content: end;
    }
    .title-Chart{
      font: normal normal 600 26px/35px Segoe UI;
      color: #5E5E5E;
      display: flex;
      width: 80%;
      justify-content: center;
      margin-bottom: 1rem;
    }
    .header-custo{
      display: flex;
      width: 100%;
      justify-content: center;
    }
    .image-container{
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .title-image{
        display: flex;
        justify-content: center;
        font: normal normal normal 28px/33px Segoe UI;
        letter-spacing: -1.51px;
        color: #008148;
    }

    .text-image{
        font: normal normal normal 16px/33px Segoe UI;
        letter-spacing: -0.3px;
        color: #4F4C4D;
    }

    .chart-container {
      width: 100%;
      padding: 1rem;
      display: flex;
      flex-direction: column-reverse;
      background-color: #F4F4F4;
      padding: 2rem;
      border-radius: 15px;
    }

    #myChart{
      width: 100%;
      height: 100%;
    }
    @media (max-width: 1367px ) {

      #myChart{
        width: 100%;
        height: 100%;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/totalCost/components/chartTotalCost/chartTotalCost.vue